import React from 'react';
import SettingsContainer, { SettingsSettingType } from '../../../components/settings/SettingsContainer';

const PurchaseSettings: React.FC = () => {
    const settings: SettingsSettingType[] = [
        {
            title: 'purchase.settings.numbering_scheme_title',
            explanationText: 'purchase.settings.numbering_scheme_explanation',
            fields: [
                {
                    type: 'text',
                    label: 'settings.general.number_sequence_title',
                    name: 'purchase_numbering_scheme',
                    placeholder: '',
                    group: 'field-row',
                    width: '30%',
                    shouldAutoFocus: false
                },
                {
                    type: 'number',
                    label: 'settings.general.next_number_label',
                    name: 'purchase_current_number',
                    width: '30%',
                    group: 'field-row'
                }
            ]
        },
    ];

    return (
        <SettingsContainer settings={settings} environmentScope={true} />
    );
};

export default PurchaseSettings;